import { Text } from '@innovationdepartment/proxima-ui';
import { useAdAccountStore } from 'stores';
import type { AudienceTableCellRendererProps, SeedAudienceTableRowProps } from 'types/audiences';

const AudienceRowCellAdAccount = ({
  row
}: AudienceTableCellRendererProps<SeedAudienceTableRowProps>) => {
  const { integrationAudiences } = row || {};
  const { metaAdAccountsList } = useAdAccountStore();

  const adAccountId = integrationAudiences?.[0]?.adAccountId;
  const [, adAccountIdFormatted] = adAccountId?.split('_') ?? [];
  const adAccount = metaAdAccountsList.find(account => account.adAccountId === adAccountId);

  return (
    <Text variant="table1Link" color="neutral100">
      {adAccount?.name ?? adAccountIdFormatted ?? '-'}
    </Text>
  );
};

export default AudienceRowCellAdAccount;
